import { Box, Text } from '@razorpay/blade/components';
import React from 'react';

interface InfoBoxProps {
  label: string;
}

export const SummaryViewItem: React.FC<InfoBoxProps> = ({ label, children }) => {
  return (
    <Box display="flex" flexDirection="column" gap="spacing.2">
      <Text size="medium" color="interactive.text.gray.muted">
        {label}
      </Text>
      {children}
    </Box>
  );
};

export const SummaryView: React.FC = ({ children }) => {
  return (
    <Box display="flex" gap="spacing.8">
      {children}
    </Box>
  );
};
